
import BillTable from './list.vue';
import { moduleType } from './options.js';

export default {
  components: {
    BillTable: BillTable
  },
  props: {
    data: {
      type: Array,
      require: true
    },
    timeZoneList: {
      type: Array,
      require: true
    },
    formValue: {
      type: Object,
      require: true
    }
  },
  data: function data() {
    return {
      formConfig: {
        // labelPosition: 'left'
        'label-width': '80px'
      },
      filterList: ['adv_name', 'timezone', 'account_type', 'module', 'invoice_name', 'company_name', 'address', 'uuid', 'bd', 'bd_am', 'pm_adv']
    };
  },

  methods: {},
  mounted: function mounted() {},

  computed: {
    columnConfig: function columnConfig() {
      return [{
        label: '广告主名称',
        prop: ''
      }];
    },
    schema: function schema() {
      return {
        type: 'object',
        properties: {
          date: {
            component: 'date-picker',
            title: '账期：',
            rules: [{
              required: true,
              message: '账期不能为空',
              trigger: 'change'
            }],
            field: {
              format: 'yyyy/MM',
              type: 'month',
              disabled: this.data[0].module === moduleType.ADVERTISER,
              'value-format': 'yyyy-MM',
              // 限定只能选择前90天的日期
              pickerOptions: {
                disabledDate: function disabledDate(time) {
                  var curDate = new Date();
                  var allowTimes = curDate.getTime() - 365 * 24 * 3600 * 1000; // 允许选择时间
                  // 禁止选择当前月份
                  // if (time.getFullYear() === curDate.getFullYear() && time.getMonth() === curDate.getMonth()) {
                  //   return true
                  // }
                  return time.getTime() > Date.now() || time.getTime() < allowTimes;
                }
              }
            }
          },
          rev: {
            component: 'input',
            title: 'rev：',
            field: {
              type: 'number',
              placeholder: '请输入具体收益'
            },
            rules: [{
              required: true,
              message: '收益不能为空',
              trigger: 'change'
            }]
          },
          cost: {
            component: 'input',
            title: 'cost：',
            rules: [{
              required: true,
              message: 'cost不能为空',
              trigger: 'change'
            }],
            field: {
              type: 'number',
              placeholder: '请输入成本'
            }
          }
        }
      };
    }
  }
};